import React, { Component } from 'react';
import { withStyles } from '@mui/styles';

import { Tab, Tabs, Paper } from '@mui/material';

import SendForm from './components/SendForm';
import Scheduler from './components/Scheduler';

import { setUrlParameter, getUrlParameter } from '../../utils';

import styles from './BroadcasterPageStyles.js';

class BroadcasterPage extends Component {
  state = {
    tab: 'sendform',
  };

  componentDidMount() {
    document.title="Broadcaster | Milkyweb";

    const tab = getUrlParameter('tab');

    if (tab) {
      this.setState({ tab });
    } else {
      this.setState({ tab: 'sendform' });
    };
  };

  onTabClick = (tab) => {
    setUrlParameter('tab', tab);

    this.setState({ tab });
  };

  render() {
    const { tab } = this.state;

    const { classes } = this.props;

    return (
      <div className={classes.container}>
        <Paper>
          <Tabs
            variant="fullWidth"
            value={tab}
            indicatorColor="primary"
            textColor="primary"
            onChange={(e, value) => this.onTabClick(value)}
          >
            <Tab style={{ maxWidth: 'none' }} value="sendform" label="Send form" />

            <Tab style={{ maxWidth: 'none' }} value="scheduler" label="Scheduler" />
          </Tabs>
        </Paper>

        {tab === 'sendform' ? <SendForm /> : tab === 'scheduler' ? <Scheduler /> : null}
      </div>
    );
  }
}

export default withStyles(styles)(BroadcasterPage);
